import { cs, Icons } from "@repo/ui";
import Attention from "../AttentionBlock";

const Attentions = () => {
	return (
		<>
			<Attention
				severity="success"
				sx={{ backgroundColor: "#E9F2E7" }}
				icon={
					<Icons.HandMoney
						sx={{
							width: "2.4rem",
							height: "2.4rem",
							color: "#538B4C",
						}}
					/>
				}
			>
				{cs.pensionCalculator.attentions.defaultAttention}
			</Attention>
		</>
	);
};

export default Attentions;
